import type { TaggingConfig } from './types';
import { consoleAdapter } from './adapters/consoleAdapter';
import { createGtmAdapter } from './adapters/gtmAdapter';
import { createTagging } from './createTagging';

export const TAGGING_APP_NAME = 'auth0';

const BASE_COUNTERNAME = 'usermanagement';

const gtmAdapter = createGtmAdapter({ dataLayerName: 'dataLayer2' });

export const taggingConfig: TaggingConfig = {
  adapters: [gtmAdapter, ...(import.meta.env.DEV ? [consoleAdapter] : [])],
  defaultContext: {
    app: 'web-auth',
    env: import.meta.env.MODE ?? 'development',
  },
};

export const tagging = createTagging(taggingConfig);

export const trackClick = (path: string) => {
  tagging.onClick({
    app_name: TAGGING_APP_NAME,
    app_countername: `${BASE_COUNTERNAME}/${path}`,
  });
};

export const trackPageView = (path: string) => {
  tagging.pageView({
    app_name: TAGGING_APP_NAME,
    app_countername: `${BASE_COUNTERNAME}/${path}`,
  });
};

export const trackError = (path: string, errorType: string) => {
  tagging.pageView({
    app_name: TAGGING_APP_NAME,
    app_countername: `${BASE_COUNTERNAME}/${path}`,
    app_error: errorType,
  });
};
